<div class="wrapper-apteka-block" [ngStyle]="{'width': isOrder ? '99.5%' : '', 'margin-bottom': isOrder ? '10px' : ''}">
    <div *ngIf="apteka.isCart" (click)="openCart()" class="move-to-cart">{{ 'move-to-cart' | transloco }}</div>

    <div *ngIf="isOrder">
        <!-- Order status msg section -->
        <div class="status-header" *ngIf="apteka.order.statusId === '2.0'">
            <div class="sticky-status" [style.background-color]="colors.primary" [style.color]="'#fff'">
                {{ 'orderReceived' | transloco }}
            </div>
            <div class="status-text">
                <p class="text-inner">{{ 'order-phrase-1.1' | transloco }}</p>
                <div class="line"></div>
                <p class="text-inner">{{ 'order-phrase-1.2' | transloco }}</p>
                <div class="line"></div>
            </div>
        </div>
        <div class="status-header"
            *ngIf="apteka.order.statusId === '3.0' || apteka.order.statusId === '3.3' || apteka.order.statusId === '3.5'">
            <div class="sticky-status" [style.background-color]="colors.third" [style.color]="'#fff'">
                {{ 'orderInProcess' | transloco }}
            </div>
            <div class="status-text">
                <ng-container *transloco="let t">
                    <p class="text-inner desktop">{{ t('order-phrase-2.1', { price: apteka.prices?.withDiscount | moneyFormat })
                        }}</p>
                </ng-container>
                <div class="line desktop"></div>
                <p class="text-inner">{{ 'order-phrase-2.2' | transloco }}</p>
                <div class="line"></div>
            </div>
        </div>
        <div class="status-header" *ngIf="apteka.order.statusId === '4.0'">
            <div class="sticky-status" [style.background-color]="colors.second" [style.color]="'#fff'">
                {{ 'orderProcessed' | transloco }}
            </div>
            <div class="status-text">
                <ng-container *transloco="let t">
                    <p class="text-inner desktop">{{ t('order-phrase-3.1', { price: apteka.prices?.withDiscount | moneyFormat })
                        }}</p>
                </ng-container>
                <div class="line desktop"></div>
                <ng-container *transloco="let t">
                    <p class="text-inner">{{ t('order-phrase-3.2', { time: apteka?.reserveTime }) }}</p>
                </ng-container>
                <div class="line"></div>
            </div>
        </div>
        <div class="status-header" *ngIf="apteka.order.statusId === '5.0'">
            <div class="sticky-status blue-border" [style.background-color]="colors.primary" [style.color]="'#fff'">
                {{ 'ordersPostpone' | transloco }}
            </div>
            <div class="status-text">
                <ng-container *transloco="let t">
                    <p class="text-inner desktop">{{ t('order-phrase-6.1', { price: apteka.prices?.withDiscount | moneyFormat })
                        }}</p>
                </ng-container>
                <div class="line desktop"></div>
                <p class="text-inner">{{ apteka?.delayReason }}</p>
                <div class="line" *ngIf="apteka?.delayReason"></div>
            </div>
        </div>
        <div class="status-header" *ngIf="apteka.order.statusId === '6.0'">
            <div class="sticky-status blue-border" [style.background-color]="colors.none"
                [style.color]="colors.primary">
                {{ 'orderCompleted' | transloco }}
            </div>
            <div class="status-text no-border">
                <ng-container *transloco="let t">
                    <p class="text-inner desktop">{{ t('order-phrase-4.1', { price: apteka.prices?.withDiscount | moneyFormat })
                        }}</p>
                </ng-container>
                <div class="line desktop"></div>
            </div>
        </div>
        <div class="status-header" *ngIf="
            apteka.order.statusId === '7.0' ||
            apteka.order.statusId === '7.1' ||
            apteka.order.statusId === '7.2' ||
            apteka.order.statusId === '7.3' ||
            apteka.order.statusId === '7.4' ||
            apteka.order.statusId === '7.5' ||
            apteka.order.statusId === '7.6' ||
            apteka.order.statusId === '7.7' ||
            apteka.order.statusId === '7.8' ||
            apteka.order.statusId === '7.9' ||
            apteka.order.statusId === '9.0' ||
            apteka.order.statusId === '9.1' ||
            apteka.order.statusId === '9.2'
            ">
            <div class="sticky-status" [style.background-color]="'#a0a0a0'" [style.color]="'#fff'">
                {{ 'orderCanceled' | transloco }}
            </div>
            <div class="status-text" [class.no-border]="!apteka.cancelReason">
                <ng-container *transloco="let t">
                    <p class="text-inner desktop">{{ t('order-phrase-5.1', { price: apteka.prices?.withDiscount | moneyFormat })
                        }}</p>
                </ng-container>
                <div class="line desktop"></div>
                <p class="text-inner">{{ apteka.cancelReason }}</p>
                <div class="line" *ngIf="apteka.cancelReason"></div>
            </div>
        </div>
        <div class="status-header"
            *ngIf="apteka.order.statusId === '8.1' || apteka.order.statusId === '8.2' || apteka.order.statusId === '8.3'">
            <div class="sticky-status" [style.background-color]="colors.second" [style.color]="'#fff'">
                {{ 'changes-in-order' | transloco }}
            </div>
            <div class="status-text" [style.padding]="'5px 0'">
                <p class="text-inner" [style.color]="colors.second" *ngIf="apteka.order?.statusId == 8.1"
                    [innerHTML]="'priceError' | transloco"></p>
                <p class="text-inner" [style.color]="colors.second" *ngIf="apteka.order?.statusId == 8.2"
                    [innerHTML]="'qtyError' | transloco"></p>
                <p class="text-inner" [style.color]="colors.second" *ngIf="apteka.order?.statusId == 8.3"
                    [innerHTML]="'priceAndQtyError' | transloco"></p>
                <div class="line error-line"></div>
                <div class="btn-actions-wrapper">
                    <button class="delete-order" (click)="cancelOrderChanges()">{{'cancelOrderAfterChanges' |
                        transloco}}</button>
                    <button class="confirm-order" (click)="confirmOrderChanges()">{{'confirmOrderAfterChanges' |
                        transloco}}</button>
                </div>
            </div>
        </div>
    </div>
    
    <div class="all-info" [ngClass]="{'dynamic-pading-bottom': isArchive}">
        <div class="title-apteka-block-archive" *ngIf="isArchive">
            <span><b [textContent]="'№' + apteka.order_number"></b> {{'from' | transloco}} <span
                    [textContent]="apteka.order_date"></span></span>
            <span><b [textContent]="apteka.order_price"></b></span>
        </div>
        <div *ngIf="isOrder && apteka.order.code" class="order-code">
            <div>
                <span *ngIf="apteka.order?.code == 'wait'">№ {{ 'order-code' | transloco }}</span>
                <span *ngIf="apteka.order?.code != 'wait'">№ {{ apteka.order?.code }}</span>
                <br />
                <span class="order-date">{{ 'from' | transloco}} {{apteka.order?.dateTimeCreated }}</span>
            </div>
            <div
              *ngIf="
                isOrder && isCurrentOrder && apteka.order.code &&
                apteka.order.statusId !== '8.1' &&
                apteka.order.statusId !== '8.2' &&
                apteka.order.statusId !== '8.3' &&
                apteka.order.statusId !== '9.0' &&
                apteka.order.statusId !== '9.1' &&
                apteka.order.statusId !== '9.2' &&
                apteka.order.statusId !== '6.0'
                "
                class="cancel-order-button"
                (click)="showConfirmPopup()">
              <p class="cancel-order-button-text">{{'cancelOrderAfterChanges' | transloco }}</p>
            </div>
            <div *ngIf="isOrder && isCurrentOrder && apteka.order.code && apteka.order.statusId === '4.0'"
              class="cancel-order-button share-order" (click)="showShareOrderPopup()">
              <p class="cancel-order-button-text">{{ 'share.order' | transloco }}</p>
              <share-buttons
                *ngIf="apteka.showShareOrder"
                class="btn-share-social-popup"
                [id]="'share-order-' + apteka.order.id"
                [theme]="'circles-light'"
                [include]="['twitter','telegram','messenger','whatsapp','viber','sms','email','copy']"
                [show]="8"
                [size]="0"
                [url]="apteka | getLinkForOrderSharing"
                [autoSetMeta]="false"
               ></share-buttons>
            </div>
            <div
              *ngIf="
                isOrder && !isCurrentOrder && apteka.order.code &&
                apteka.order.statusId === '6.0' ||
                apteka.order.statusId === '7.0' ||
                apteka.order.statusId === '7.1' ||
                apteka.order.statusId === '7.2' ||
                apteka.order.statusId === '7.3' ||
                apteka.order.statusId === '7.4' ||
                apteka.order.statusId === '7.5' ||
                apteka.order.statusId === '7.6' ||
                apteka.order.statusId === '7.7' ||
                apteka.order.statusId === '7.8' ||
                apteka.order.statusId === '7.9' ||
                apteka.order.statusId === '9.0' ||
                apteka.order.statusId === '9.1' ||
                apteka.order.statusId === '9.2'
                "
                class="cancel-order-button"
                (click)="showConfirmPopup()">
              <p class="cancel-order-button-text">{{ 'remove.order.from.history' | transloco }}</p>
          </div>
        </div>
        <span class="title-apteka-block" [textContent]="apteka.name"></span>
        <span class="address-apteka-block" [class.cart-adress]="isCart" [textContent]="apteka.address"></span>
        <span class="info-apteka-block toMap" *ngIf="!isCart && !isOrder && !isPopup">
            {{ apteka.distance }}
            <span class="show-in-map"
                (click)="toCurrentMap([apteka.latitude, apteka.longitude], true, apteka.id)">{{'toMap' |
                transloco}}</span>
        </span>

        <ng-template [ngTemplateOutlet]="infoTemplate"></ng-template>

        <span *ngIf="!isArchive && !isCart" [ngStyle]="{'display' : isOrder ? 'none' : 'block'}"
            class="update">{{'updated' | transloco}}
            <br class="update-separator">
            {{apteka.update}}</span>

        <ng-container *ngIf="isArchive">
            <span class="status-order" [textContent]="apteka.order_status | transloco"></span>
        </ng-container>

        <div *ngIf="!isOrder" class="btn-apteka-block" [ngClass]="{'dynamic-top': isArchive}">

            <ng-container *ngIf="!isCart else deleteOrder">
                <bz-button (click)="onToOrderPharmcy(apteka)"
                    [type]="!isArchive ? (apteka.isCartCurrent ? colors.none : colors.primary) : colors.primary"
                    [k]="1.45" [text]="!isArchive
                      ? ((apteka.isCartCurrent ? 'cancel' : (apteka.products?.length > 1 ? 'toAllOrder' : 'toOrder')) | transloco)
                        : ('cancel' | transloco)"
                    [textColor]="(!isArchive && apteka.isCartCurrent) ? '#449bd1' : '#FFFFFF'"
                    [borderColor]="(!isArchive && apteka.isCartCurrent) ? '#449bd1' : ''" [size]="{w: 55, h: 25}"
                    [radius]="['16px ','0px ','0px ','16px']">
                </bz-button>
            </ng-container>
            <ng-template #deleteOrder>
                <div class="btnDelOrder" (click)="deleteFromDB(apteka)" innerHTML="{{'deleteOrder' | transloco}}"></div>
            </ng-template>

        </div>
    </div>

    <div *ngIf="!isArchive" class="price-info" [ngStyle]="{
        'margin-top': isOrder ? '0px' : '10px',
        'justify-content': totalProductsSum == totalProductsOldSum ? 'center' : ''}">
        <ng-template [ngTemplateOutlet]="priceTemplate"></ng-template>
    </div>

    <div class="count-list">
        <span
            *ngIf="!isArchive && !isCart && apteka.products?.length > 1 && apteka.products?.filter(countCheck).length > 0"
            class="count-list-added">
            {{'addedIn' | transloco}} "{{'addedInCart' | transloco}}" {{apteka.products?.filter(countCheck).length}}
            {{'of' | transloco}} {{apteka.products?.length}}
        </span>

        <br>
        <span class="btn-ddl" style="padding-top: 5px;">
            <span [ngStyle]="{
                'top': apteka.products?.filter(countCheck).length > 0 ? '-25px' : '-25px',
                'background': !isArchive && !isPopup ? 'none': '#449bd1',
                'color': !isArchive && !isPopup ? '#292929bf' : ''}" class="btn-ddl-icon" (click)="swithIsListInfo()">
                <span class="ddl-icon" [ngStyle]="{
                    'background-color': !isArchive ? '#292929bf' : '#FFFFFF',
                    'mask': (isCart || isOrder ? !isListInfo : !apteka?.isOpenInfo) ? 'url(../../../../assets/down-arrow-apteka-block.svg) no-repeat center' : 'url(../../../../assets/up-arrow-apteka-block.svg) no-repeat center',
                    '-webkit-mask': (isCart || isOrder ? !isListInfo : !apteka?.isOpenInfo) ? 'url(../../../../assets/down-arrow-apteka-block.svg) no-repeat center' : 'url(../../../../assets/up-arrow-apteka-block.svg) no-repeat center',
                    '-webkit-mask-size': 'contain',
                    'mask-size': 'contain'
                }"></span>
                <span *ngIf="!isArchive" class="btn-ddl-count">{{'details' | transloco}}
                    <ng-container *ngIf="!isCart && apteka.searchTotalNum > 1">
                        <span [ngStyle]="{'color' : (apteka.productTotalNum < apteka.searchTotalNum) ? '#ef5086' : ''}">
                            {{apteka.productTotalNum}} {{'of' | transloco}} {{apteka.searchTotalNum}}
                        </span>
                    </ng-container>
                    <ng-container *ngIf="(isOrder || isCart) && apteka.products.length > 1">
                        <span>{{ apteka.products.length }} {{ 'of' | transloco }} {{ apteka.products.length }}</span>
                    </ng-container>
                </span>
            </span>

        </span>
        <span *ngIf="
              (apteka.products?.length === 1) && apteka?.products[0]?.balanceNum < apteka?.requestOty && isPharmaciesPage && apteka?.products[0]?.packageContentType
              " class="count-list-added qty">{{'available' | transloco}}:
            <span
                *ngIf="({balanceNum: apteka?.products[0]?.balanceNum, packageContentNum: apteka?.products[0]?.packageContentNum } | quantityText)[1] == '0'">
                {{
                (+({
                balanceNum: apteka?.products[0]?.balanceNum,
                packageContentNum: apteka?.products[0]?.packageContentNum
                } | quantityText)[0] | declension)
                }}
            </span>

            <span
                *ngIf="({balanceNum: apteka?.products[0]?.balanceNum, packageContentNum: apteka?.products[0]?.packageContentNum } | quantityText)[1] !== '0'">
                {{
                (+({
                balanceNum: apteka?.products[0]?.balanceNum,
                packageContentNum: apteka?.products[0]?.packageContentNum
                } | quantityText)[0] | declension) + ' ' +
                ({
                balanceNum: apteka?.products[0]?.balanceNum,
                packageContentNum: apteka?.products[0]?.packageContentNum
                } | quantityText)[1] + ' ' + (apteka?.products[0]?.packageContentType.toLowerCase() | declensionString :
                +({
                balanceNum: apteka?.products[0]?.balanceNum,
                packageContentNum: apteka?.products[0]?.packageContentNum
                } | quantityText)[1])
                }}
            </span>

        </span>

        <span *ngIf="
            (apteka.products?.length === 1) && apteka?.products[0]?.balanceNum < apteka?.requestOty && isPharmaciesPage && !apteka?.products[0]?.packageContentType
            " class="count-list-added qty">{{'available' | transloco}}: {{
            (+({
            balanceNum: apteka?.products[0]?.balanceNum,
            packageContentNum: apteka?.products[0]?.packageContentNum
            } | quantityText)[0] | declension)
            }}
        </span>
    </div>

    <div class="list-preparat" [ngClass]="{'switch': (isCart || isOrder ? isListInfo : apteka?.isOpenInfo)}">
        <ng-container *ngIf="(isCart || isOrder ? isListInfo : apteka?.isOpenInfo)">
            <ng-container *ngFor="let item of apteka.products, let i = index; trackBy: trackById">
                <bz-product class="bz-product-in-apteka" [isCart]="isCart" [isOrder]="isOrder" [BzProduct]="item"
                    [isPharmaciesPage]="isPharmaciesPage" [idApteka]="apteka.id" [apteka]="apteka"
                    [isListCounts]="false" [isNameInInfoDetails]="true" [isNameInInfoPrices]="true"
                    [isBtnToPharmacy]="false" [isBtnToMenu]="false" [isPharmacyPopUp]="isPopUp"
                    [locationORprice]="typeProduct.price" [reviewsORcounts]="typeProduct.counts"
                    (onClickProduct)="onEmmitContainer()"></bz-product>

                <ng-container *ngIf="i < apteka.products.length - 1">
                    <span class="separator"></span>
                </ng-container>

            </ng-container>
        </ng-container>
    </div>

</div>


<ng-template #infoTemplate>
    <span class="info-apteka-block time" *ngIf="apteka.opening" [textContent]="apteka.opening"></span>
    <span *ngIf="(isPharmaciesPage || isPopup) && apteka?.isQuantityEnoughList"
        class="info-apteka-block isQuantityEnough" [textContent]="'notFullQtyFromList' | transloco"></span>
    <span *ngIf="!isCart && !isOrder && (isPharmaciesPage || isPopup) && !apteka.isPartialSale"
        class="info-apteka-block isPartialSale cursor-pointer">{{'partialSale' | transloco}}</span>
    <span class="info-apteka-block phone" *ngIf="apteka.phone" [textContent]="apteka.phone"></span>
</ng-template>

<ng-template #priceTemplate>
    <span *ngIf="totalProductsSum !== totalProductsOldSum" class="withoutDiscount"
        [textContent]="totalProductsOldSum | moneyFormat"></span>
    <span *ngIf="!isOrder" class="withDiscount" [textContent]="totalProductsSum | moneyFormat"></span>
    <span class="discount" [textContent]="totalEconomySum | moneyFormat"></span>
    <span *ngIf="isOrder && apteka.order.code" class="order-total-price">{{ apteka.prices?.withDiscount | moneyFormat
        }}</span>
</ng-template>